<div class="modal-header">
  <button *ngIf="currentModal?.id === 'looseArticle-form' && currentStep?.id === 'looseArticle-form-s2'" type="button"
    class="back btn_iconOnly" svgIcon [icon]="'left-arrow'" (click)="goBack()">
  </button>
  <div class="modal-title pull-left">
    <h1 class="h2">
      {{ currentStep?.header?.modalTitleOverride || currentModal?.title | translate }}
      <ng-container *ngIf="currentModal?.id === 'offerPreview-form' && (currentStepIndex + 1) <= (currentModal?.steps?.length - 1)">{{'/ '}} {{"GENERAL.STEP" | translate}} {{currentStepIndex + 1}} {{"GENERAL.OF" | translate}} {{(currentModal?.steps?.length - 1)}}</ng-container>
    </h1>
    <h2 class="copy copy_small copy_normal" *ngIf="currentStep?.header?.title">
      {{currentStep?.header?.title | translate}}
    </h2>
    <nav *ngIf="breadcrumbs.length">
      <ul class="modal-breadcrumbs">
        <li *ngFor="let breadcrumb of breadcrumbs" [ngClass]="{ 'visited': breadcrumb.visited }">
          {{ breadcrumb.text | translate }}
        </li>
      </ul>
    </nav>
    <div *ngIf="this.currentStep?.header?.image" class="modal-header-image">
      <div svgImage [image]="this.currentStep?.header?.image"></div>
    </div>
    <div *ngIf="displayHeaderBack()" class="modal-header-link">
      <button type="button" class="btn btn_link" (click)="goBack()" svgIcon [icon]="'arrow'">
        {{(currentStep?.header?.link?.text | translate)}}
      </button>
    </div>
    <div *ngIf="errors" class="modal-error">
      <h2 class="h5"><i svgIcon [icon]="'warning'"></i>Server Errors</h2>
      <ul>
        <li *ngFor="let err of errors">{{ err.message.split(';').pop() }}</li>
      </ul>
    </div>
  </div>
  <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true"></span>
  </button>
</div>

<div class="modal-body" [ngClass]="{ 'modal-body_resetMinHeight': resetMinHeight }">
  <ng-template appDynamicInsertion></ng-template>
</div>

<div *ngIf="!hideFooter" class="modal-footer">
  <div class="modal-action d-flex justify-content-between align-items-center flex-column flex-sm-row">
    <div class="modal-footer-cancelBtn" *ngIf="showCancelBtn">
      <button type="button" class="btn btn_sm btn_ghost" (click)="closeModal()">
        {{ "GENERAL.CANCEL" | translate}}
      </button>
    </div>
    <div class="modal-footer-link" *ngIf="footerLinkFunction !== 'HIDE_LINK'">
      <button *ngIf="displayBack()" type="button" class="btn btn_link" (click)="goBack()">{{ "GENERAL.BACK" | translate
        }}</button>
      <button *ngIf="hasFooterLink && !footerLinkFunction" type="button" class="btn btn_link"
        [disabled]="currentStep.footer?.link?.disabled"
        (click)="openNewModal(currentStep.footer?.link?.modalId)">
        {{currentStep.footer?.link?.text | translate}}
      </button>
      <button *ngIf="footerLinkFunction === 'RESET_FORM'" type="button" class="btn btn_icon btn_link" svgIcon
        [icon]="'reset'" (click)="triggerComponentFunction()">
        {{currentStep.footer?.link?.text | translate}}
      </button>
    </div>
    <div class="modal-footer-btn">
      <ng-container *ngIf="hasFooterCheckbox">
        <app-checkbox class="modal-footer-checkbox"
          [options]="[{name: currentStep.footer?.checkbox?.text, isChecked: footerCheckboxChecked}]" [mainForm]="form"
          [controlName]="'checkbox'" [labelKey]="'name'" [layoutMod]="['box', 'small']">
        </app-checkbox>
      </ng-container>

      <button type="button" #goForwardButton class="btn btn_sm btn_primary"
        (click)="footerLinkFunction === 'GO_TO_DASHBOARD' ? goToDashboard() : goForward()"
        [disabled]="isForwardButtonDisabled || isLoading">
        {{(currentStep?.footer?.saveBtnName || defaultGoNextButtonText) | translate}}
      </button>
    </div>
  </div>
</div>
